<template>
  <div class="page_404">
    <tx-header class="bd-3"></tx-header>
    <div class="content">
      <div class="main">
        <img src="../assets/default/404.png" alt="404.png" class="not-found-img">
        <p class="tc f18 mt20">哎呀，迷路了...</p>
        <p class="mt30 text-info">
          <el-button plain size="small" class="w100" @click="$router.go(-1)">返回上级</el-button>
          <el-button type="primary" size="small" class="w100" @click="$router.replace('/')">返回首页</el-button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'cjfx_init'
  }
</script>

<style lang='less'>
  .page_404 {
    height: 100%;
    text-align: center;
    .content{
      height: calc(100vh - 200px);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
</style>
